module.exports = __webpack_public_path__ + "img/u1005.96b701e6.svg";